import { SearchDataModel } from './search-data.model';
import { createReducer, on, Action } from '@ngrx/store';
import * as SearchDataActions from './search-data.actions';

const initialState: SearchDataModel = new SearchDataModel();

const reducer = createReducer(
  initialState,
  on(
    SearchDataActions.setSearchData,
    (state, { data }: SearchDataModel) => ({ ...state, data } as SearchDataModel)
  )
);

export function searchDataReducer(state: SearchDataModel, action: Action) {
  return reducer(state, action);
}
